import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as bytes from 'bytes';
import { custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { CookieService } from 'ngx-cookie-service';
import { InvoiceService } from '../../../providers/invoice.service';
import { ServiceService } from '../../../providers/service.service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';


@Component({
  selector: 'app-renew',
  templateUrl: './renew.component.html',
  styleUrls: ['./renew.component.scss']
})
export class RenewComponent extends BaseComponent implements OnInit {
  // id: any;
  services: any = [];
  relatedServices: any = [];
  user: any;

  service_length_shared = [
    { value: 1, name: '1MONTH' },
    { value: 3, name: '3MONTH' },
    { value: 6, name: '6MONTH' },
    { value: 12, name: '1YEAR' },
  ];
  @Output() done: EventEmitter<object> = new EventEmitter<object>();

  constructor(
    public serviceService: ServiceService,
    public route: ActivatedRoute,
    public translator: TranslateService,
    public userService: UserService,
    public invoiceService: InvoiceService,
    private router: Router,
    public cookieService: CookieService,
    public titleService: Title,) {
    super(serviceService, translator, cookieService, titleService);
  }

  async ngOnInit() {
    await this.load();
  }

  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.user.service_type !== 'VPS') {

        this.serviceService.getServices(this.user.username).subscribe((result1: any) => {
          result1.forEach(element => {
            let service_group = this.services.find(obj => obj.group_name === element.service_group);
            if (!service_group) {
              service_group = {
                group_name: element.service_group,
                services: [element]
              };
              this.services.push(service_group);
            } else {
              service_group.services.push(element);
            }

          });

          this.services.forEach(group_service => {
            group_service.services.forEach(service => {
              service.hasPenalty = service.rules.some(i => i.external_penalty > 0);
              service.hasDownDisc = service.rules.some(i => i.download_discount > 0);
              service.hasUpDisc = service.rules.some(i => i.upload_discount > 0);
              service.hasIntDisc = service.rules.some(i => i.internal_discount > 0);
              service.hasSocDisc = service.rules.some(i => i.social_discount > 0);
            });
          });
          resolve(true);
        }, error => {
          reject(error);
        });

        this.serviceService.getRelatedServices(this.user.username).subscribe((result1: any) => {
          result1.forEach(element => {
            let service_group = this.relatedServices.find(obj => obj.group_name === element.service_group);
            if (!service_group) {
              service_group = {
                group_name: this.translator.instant('RELATED_SERVICES'),
                services: [element]
              };
              this.relatedServices.push(service_group);
            } else {
              service_group.services.push(element);
            }

          });

          this.relatedServices.forEach(group_service => {
            group_service.services.forEach(service => {

              service.hasPenalty = service.rules.some(i => i.external_penalty > 0);
              service.hasDownDisc = service.rules.some(i => i.download_discount > 0);
              service.hasUpDisc = service.rules.some(i => i.upload_discount > 0);
              service.hasIntDisc = service.rules.some(i => i.internal_discount > 0);
              service.hasSocDisc = service.rules.some(i => i.social_discount > 0);
            });
          });
          if (this.relatedServices && this.relatedServices.length) {
            this.services = this.relatedServices.concat(this.services);
          }
        }, error => {
          reject(error);
        });
      } else {
        this.serviceService.getVpses(this.user.username).subscribe((result1: any) => {
          result1.forEach(element => {
            let service_group = this.services.find(obj => obj.group_name === element.group_name);
            if (!service_group) {
              service_group = {
                group_name: element.group_name,
                services: [element]
              };
              this.services.push(service_group);
            } else {
              service_group.services.push(element);
            }

          });

          this.services.forEach(group_service => {
            group_service.services.forEach(service => {
              this.serviceService.getVpsPrices(service.id).subscribe((result: any) => {
                service.prices = result;
              });
            });
          });
          resolve(true);
        }, error => {
          reject(error);
        });
      }

    });
  }

  checkAddInvoice(servicePriceId, service) {
    if (!service.self_service && this.user.service_name != service.service_name && !(this.role.includes('SALES_OFC') || this.role.includes('INSTALLER'))) {
      notify(this.translator.instant('NOT_SELF_SERVICE'), 'info', 7000);
    } else if (this.user.bandwidth && bytes(`${this.user.bandwidth.split('/')[0]}b`) < service.bps) {
      const result = custom({
        title: this.translator.instant('CONFIRM'), message: this.translator.instant('FASTER_SPEED_CONFIRMATION'), buttons: [{
          text: this.translator.instant('YES'), onClick: function () {
            return true;
          }
        }, {
          text: this.translator.instant('NO'), onClick: function () {
            return false;
          }
        }]
      });
      result.show().done((dialogResult) => {
        if (!dialogResult) {
          result.hide();
        } else {
          this.addInvoice(servicePriceId);
        }
      });
    } else {
      this.addInvoice(servicePriceId);
    }
  }
  addInvoice(servicePriceId) {
    this.invoiceService.addInvoice(this.selectedAccount, this.user.username, servicePriceId,
      this.user.service_type !== 'VPS' ? 'service' : 'vps').subscribe((result: any) => {
        this.done.emit();
        this.handleSuccess();
        if (result[0][0].payable) {
          this.router.navigate(['/sales/basket']);
        }
      }, error => {
        this.handleError(error);
        if (error.message.includes('پیش فاکتور دیگری برای این سرویس ثبت شده است')) {
          this.router.navigate(['/sales/basket']);
        }
      });
  }
}
